import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { logKioskError } from 'shared/services/LogService';

import Loading from 'shared/components/Loading';
import TopBar from 'app/components/TopBar';
import Catalog from 'app/components/Catalog';
import Gallery from 'app/components/Gallery';
import Receipt from 'app/components/Receipt';
import PrePrintGallery from 'app/components/PrePrintGallery';
import GalleryWorker from 'app/components/GalleryWorker';
import NewPhotos from 'shared/components/NewPhotos';
import SelfieUpload from 'shared/components/SelfieUpload';


import {
  getStore
} from 'shared/services/Store';

import {
  onUserMessage
} from 'shared/services/Pusher';

import {
  me,
  getVisits,
  setVisit,
  getGuests,
  fetchMergedStories
} from 'app/actions/kioskActions';

import {
  getMoments,
  getSelections,
  getPurchasedMomentIds,
  getPurchaseCalculations
} from 'shared/actions/cartActions';

import {
  VIEW_CATALOG,
  VIEW_GALLERY,
  VIEW_CART,
  VIEW_RECEIPT,
  VIEW_PRE_PRINT
} from 'app/actions/types';

import {
  CLUB_MED_LOGIN_TYPE,
  GALLERY_SCREEN,
  CART_SCREEN
} from 'app/utils/Constants';

import {
  storeResource
} from 'app/utils/Utils';

import { KeyboardReturn } from '@mui/icons-material';

const styles = () => ({
  view: {
    position: 'relative',
    display: 'block',
    width: '100%'
  }
});

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      kioskNotFound: false,
      showNewPhotos: false,
      showSelfieUpload: false
    }

    this.store = getStore();
  }

  componentDidMount() {
    const {
      user
    } = this.props;
    const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
    const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;

    if (!isViewPhotos) {
      this.auth()
        .then(() => this.loadMoments())
        .then(() => this.loadPurchaseCalculations())
        .then(() => this.loadSelections())
        .then(() => Promise.all([
          this.loadVisits(),
          this.loadMergeStories(),
          this.loadGuests(),
          this.loadPurchasedMomentIds()
        ]))
        .then(() => this.setState({ loading: false }))
        .then(() => this.loadSelfieUpload())
        .catch(err => {
          console.error(err);
          this.setState({ loading: false });
        });
    } else {
      this.auth()
        .then(() => this.setState({ loading: false }))
        .catch(err => {
          console.error(err);
          this.setState({ loading: false });
        });
    }
  }

  loadSelfieUpload() {
    const { user, settings } = this.props;
    if (settings.facial_rec) {
      onUserMessage(user.id, "selfie", "available", msg => this.onNewPhotosAvailable());
      this.setState({ showSelfieUpload: true });
    }
  }

  //shouldComponentUpdate(newProps, newState) {
  //  return newProps.view !== this.props.view ||
  //    newState.loading !== this.state.loading ||
  //    newProps.loggedIn !== this.props.loggedIn;
  //}

  onNewPhotosAvailable() {
    this.setState({ showNewPhotos: true });
  }

  componentDidCatch(error, info) {
    logKioskError(error, info);
  }

  componentDidUpdate() {
    // hotfix for now - reload cart moments on view change
    if (this.props.user && this.view !== this.props.view) {
      this.view = this.props.view;
      this.loadMoments();
    }
  }

  auth() {
    const { settings, me } = this.props;
    return me(settings.token);
  }

  loadMergeStories() {
    const { settings, user, fetchMergedStories } = this.props;

    if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
      return Promise.resolve();
    } else {
      return fetchMergedStories(settings.token, user.story_id);
    }
  }

  loadVisits() {
    const {
      settings,
      user,
      getVisits,
      setVisit
    } = this.props;

    if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
      // if family_id, get visits.
      if (user.family_id) {
        return getVisits(settings.token, user.family_id);

      } else {
        // no family_id or associated visits. add current visit
        let visit = {};
        visit.id = user.visit_id;
        visit.room = user.room;
        visit.story_id = user.story_id;

        return setVisit(visit);
      }
    } else {
      return Promise.resolve();
    }
  }

  loadGuests() {
    const {
      settings,
      user,
      getGuests
    } = this.props;

    if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
      return getGuests(settings.token, user.story_id);
    } else {
      return Promise.resolve();
    }
  }

  loadMoments() {
    const { getMoments, settings, user } = this.props;
    const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
    const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;
    let opts = {
      includePurchased: true
    }

    if (!isViewPhotos) {
      return getMoments(settings.token, user.story_id, opts);
    }
  }

  loadPurchaseCalculations() {
    const { user } = this.props;
    const { moments } = this.store;

    // Pull max moments from Redux and store
    let maxQuantity = Math.max(this.props.moments.allIds.length, moments.allIds.length);

    return this.props.getPurchaseCalculations(user.story_id, maxQuantity);
  }

  loadPurchasedMomentIds() {
    // these are used to hide purchased images in the catalog.
    // the cart images rely on the moment.purchased flag instead
    const { user, getPurchasedMomentIds } = this.props;

    return getPurchasedMomentIds(user.story_id);
  }

  loadSelections() {
    const { user, getSelections } = this.props;

    return getSelections(user.story_id);
  }

  closeSelfieUpload() {
    if (this.state.showSelfieUpload) {
      this.setState({ showSelfieUpload: false });
      window.currentModal.close();
      document.body.style.overflowY = 'scroll';
    }
  }

  closeNewPhotos() {
    if (this.state.showNewPhotos) {
      this.setState({ showNewPhotos: false });
      window.currentModal.close();
      document.body.style.overflowY = 'scroll';
    }
  }

  onViewPhotos() {
    this.loadMoments();
  }

  render() {
    const { classes, store, settings, user } = this.props;

    if (this.state.loading) {
      return (<Loading />);
    }

    if (!this.props.loggedIn) {
      return (<Redirect to={`${settings.token}/login`} />);
    }

    var view;
    const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
    const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;

    if (isViewPhotos) {
      view = (<PrePrintGallery />);
    } else {
      switch (this.props.view) {
        case VIEW_CATALOG:
          view = (<Catalog store={store} settings={settings} user={user} />);
          break;
        case VIEW_GALLERY:
          view = (<Gallery screen={GALLERY_SCREEN} />);
          break;
        case VIEW_CART:
          view = (<Gallery screen={CART_SCREEN} />);
          break;
        case VIEW_RECEIPT:
          view = (<Receipt />);
      }
    }

    let selfieModals = null;
    if (settings.facial_rec) {
      selfieModals = (
        <div>
          <SelfieUpload open={this.state.showSelfieUpload} onClose={this.closeSelfieUpload.bind(this)} storyId={user.story_id} loggedIn={this.props.loggedIn} />
          <NewPhotos open={this.state.showNewPhotos} onClose={this.closeNewPhotos.bind(this)} storyId={user.story_id} isKiosk={true} onViewPhotos={this.onViewPhotos.bind(this)} />;
        </div>
      )
    }

    return (
      <div>
        <TopBar />
        <div className={classes.view}>
          <GalleryWorker>
            {view}
          </GalleryWorker>
          {selfieModals}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  view: state.kioskReducer.view,
  loggedIn: state.kioskReducer.loggedIn,
  moments: state.cartReducer.moments
});

export default connect(mapStateToProps, { me, getVisits, setVisit, getGuests, fetchMergedStories, getMoments, getSelections, getPurchasedMomentIds, getPurchaseCalculations })(withStyles(styles)(withRouter(Home)));
